import script from "./FormItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormItem.vue?vue&type=script&setup=true&lang=ts"

import "./FormItem.vue?vue&type=style&index=0&id=718d515c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-718d515c"]])

export default __exports__